import { Pipe, PipeTransform } from '@angular/core';
import { LssDeploymentEntity } from '../store/deployment.datamodel';

/**
 * Pipe to determine if the exclusion checkbox of a given entity should be shown.
 */
@Pipe({
    name: 'showExclusion',
    standalone: false
})
export class ShowExclusionPipe implements PipeTransform {

  transform(entity: LssDeploymentEntity, isIndeterminate: boolean): boolean {
    return entity.isExcluded || isIndeterminate || entity.deployedParent !== undefined;
  }

}
